import React, { useEffect, useMemo } from "react";

import {
  HCheckbox,
  HInput,
  HMaskedInput,
  HSelect,
  passParamsThrough,
} from "../../../validation/HForm";
import { contactTypes } from "../../../helpers/data-constants";

const ContactsAdd = (props) => {
  const { watch, control, getValues, setValue, unregister } = props;
  const { contactType, phone } = watch(["contactType", 'phone']);

  const initialPhoneValue = useMemo(() => phone || '', []);
  const mobile = contactType === "Мобильный";

  useEffect(() => {
    const isUpdateMode = !!initialPhoneValue;

    if (isUpdateMode) {
      const updatedValue = getValues().phone;
      setValue("phone", updatedValue);
    } else {
      setValue("phone", initialPhoneValue);
    }
  }, [contactType, setValue, getValues, initialPhoneValue]);

  useEffect(() => {
    return () => {
      if (unregister) {
        unregister("active");
      }
    };
  }, [unregister]);

  return passParamsThrough(
    <fieldset>
      <div className="form-element">
        <label className="form-element-label" htmlFor="contactsType">
          Тип
        </label>
        <div className="form-element-data">
          <HSelect
            h="true"
            className="input"
            type="text"
            name="contactType"
            id="contactType"
            options={["", ...contactTypes]}
          />
        </div>
      </div>
      <div className="form-element">
        <label className="form-element-label" htmlFor="phone">
          Телефон
        </label>
        <div className="form-element-data">
          <HMaskedInput
            h="true"
            className="input"
            type="phone"
            name="phone"
            id="phone"
            mask={mobile ? "+37\\5 99 999 99 99" : ""}
            control={control}
            defaultValue={initialPhoneValue}
          />
        </div>
      </div>

      <div className="form-element">
        <label className="form-element-label" htmlFor="email">
          Электронная почта
        </label>
        <div className="form-element-data">
          <HInput
            h="true"
            className="input"
            type="text"
            name="email"
            id="email"
          />
        </div>
      </div>
      <div className="form-element">
        <label className="form-element-label" htmlFor="clientAddCountry">
          Активен
        </label>
        <div className="form-element-data">
          <HCheckbox h="true" label="Активен" name="active" />
        </div>
      </div>
    </fieldset>,
    props
  );
};

export default ContactsAdd;
